import { SmartComponent } from "smart-component-js";
import Swiper, {Navigation, Pagination} from "swiper";

class CalendarCarouselLandingComponent extends SmartComponent {
  constructor(element, parentComponent, params) {
    super(element, parentComponent, params);
    this.element = element;
    this.init();
  }

  init() {
    new Swiper(this.element.querySelector(".calendar-carousel__swiper"), {
      loop: false,
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: this.element.querySelector(".calendar-carousel__button--next"),
        prevEl: this.element.querySelector(".calendar-carousel__button--prev"),
      },
      spaceBetween: 15,
      slidesPerView: "auto",
      centeredSlides: true,
      slidesPerGroup: 1,
      effect: "coverflow",
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 50,
        modifier: 0,
        slideShadows: false,
      },
      watchOverflow: true,
    });
  }
}
export default CalendarCarouselLandingComponent;
